module.exports = __webpack_public_path__ + "img/img27.4bb72142.jpg";